import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const DiscordIcon: React.FC<CardGradientProps> = ({
  className,
  width = "1.74vw",
  height = "1.74vw",
}) => {
  return (
    <svg
      width={height}
      height={width}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6248 5.05554C18.2221 4.41658 16.7191 3.94611 15.1466 3.67696C15.1178 3.67167 15.089 3.68438 15.0751 3.71087C14.8819 4.05207 14.6673 4.49817 14.5179 4.84785C12.8269 4.59672 11.1446 4.59672 9.48783 4.84785C9.33731 4.48969 9.11527 4.05207 8.92099 3.71087C8.90604 3.68544 8.87723 3.67273 8.84947 3.67696C7.27812 3.94611 5.77402 4.41658 4.37133 5.05554C4.35958 5.06083 4.34891 5.06931 4.34143 5.08097C1.48908 9.31099 0.707654 13.4372 1.09089 17.5125C1.09302 17.5326 1.1037 17.5517 1.11971 17.5633C3.00171 18.9356 4.82501 19.7684 6.61414 20.3205C6.64296 20.329 6.67285 20.3184 6.691 20.2951C7.11372 19.7218 7.49162 19.1167 7.81507 18.4799C7.83429 18.4428 7.81506 18.3983 7.77663 18.3835C7.17777 18.1578 6.60878 17.8833 6.06009 17.5718C6.01632 17.5464 6.01314 17.4849 6.05263 17.4553C6.16792 17.3694 6.28321 17.2804 6.39316 17.1903C6.41344 17.1734 6.44119 17.1702 6.46467 17.1808C10.0653 18.8126 13.9638 18.8126 17.5218 17.1808C17.5453 17.1692 17.573 17.1734 17.5933 17.1893C17.7033 17.2794 17.8186 17.3694 17.9349 17.4553C17.9744 17.4849 17.9723 17.5464 17.9285 17.5718C17.3809 17.8897 16.8109 18.1588 16.2109 18.3835C16.1714 18.3983 16.1543 18.4428 16.1736 18.481C16.5045 19.1157 16.8813 19.7207 17.2966 20.2951C17.3136 20.3194 17.3446 20.33 17.3734 20.3215C19.1711 19.7695 20.9944 18.9366 22.8764 17.5644C22.8924 17.5527 22.9031 17.5337 22.9052 17.5146C23.3642 12.8035 22.1366 8.71124 19.6525 5.08309C19.6461 5.07143 19.6365 5.06189 19.6237 5.0566L19.6248 5.05554ZM8.35093 15.0308C7.26636 15.0308 6.37395 14.0433 6.37395 12.83C6.37395 11.6167 7.25034 10.6292 8.35093 10.6292C9.45152 10.6292 10.3461 11.6263 10.3279 12.83C10.3279 14.0433 9.45152 15.0308 8.35093 15.0308ZM15.6622 15.0308C14.5776 15.0308 13.6852 14.0433 13.6852 12.83C13.6852 11.6167 14.5616 10.6292 15.6622 10.6292C16.7628 10.6292 17.6574 11.6263 17.6392 12.83C17.6392 14.0433 16.7724 15.0308 15.6622 15.0308Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DiscordIcon;
